import { apiService } from '@/services/APIService';

export const getRegions = (params) => apiService.get('/region', params);
export const getCachedRegions = (params) => apiService.get('/region', params);

export const showRegion = (id, params) => apiService.get(`/region/${id}`, params);

export const getMunicipalities = (params) => apiService.get('/municipality', params);
export const showMunicipality = (id, params) => apiService.get(`/municipality/${id}`, params);
